import { variableInitial } from "../../store/InitialStore";
import * as types from "../../actions/ActionTypes";
export default function VariantsListReducer(state = variableInitial, action) {
  const { type, payload } = action;
  switch (type) {
    case types.SET_VARIABLES_LIST:
      return { data: payload };
    default:
      return state;
  }
}
